export type ReceptionTypeId = number;

export default class ReceptionType {
  id: ReceptionTypeId | null = null;
  title: string | null = null;
  description: string | null = null;
  longDescription: string | null = null;
  shortDescription: string | null = null;
}
